import { render, staticRenderFns } from "./CrossSalonDialog.vue?vue&type=template&id=0f7cc87c&scoped=true"
import script from "./CrossSalonDialog.vue?vue&type=script&lang=js"
export * from "./CrossSalonDialog.vue?vue&type=script&lang=js"
import style0 from "./CrossSalonDialog.vue?vue&type=style&index=0&id=0f7cc87c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7cc87c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FixitDialog: require('/salonhomepage/client/components/FixitDialog.vue').default})
